import {useQuery} from '@tanstack/react-query'
import {sanityClient} from '@/lib/sanity'
import {RELATED_POSTS_QUERY} from '@/lib/sanityQueries'
import type {BlogCategory, BlogPostSummary} from '@/types/blog'

interface Args {
  slug: string | undefined
  categories: BlogCategory[] | undefined
  limit?: number
}

export const useRelatedBlogPosts = ({slug, categories, limit = 3}: Args) =>
  useQuery({
    queryKey: ['blog', 'related', slug, categories, limit],
    queryFn: () =>
      sanityClient.fetch<BlogPostSummary[]>(RELATED_POSTS_QUERY, {
        slug,
        categories,
        limit,
      }),
    enabled: Boolean(slug && categories && categories.length > 0),
  })
